import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=636a469a&scoped=true&"
import script from "./insights.vue?vue&type=script&lang=js&"
export * from "./insights.vue?vue&type=script&lang=js&"
import style0 from "./insights.vue?vue&type=style&index=0&id=636a469a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a469a",
  null
  
)

export default component.exports